import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { customInterrogationSchema } from './entities';

export const types = {
  RECEIVE_CUSTOM_INTERROGATION:
    'processes/customInterrogations/detailsPage/RECEIVE_CUSTOM_INTERROGATION',
  UPDATE_INTERROGATION_REQUEST:
    'processes/customInterrogations/detailsPage/UPDATE_INTERROGATION_REQUEST',
  UPDATE_INTERROGATION_ERROR:
    'processes/customInterrogations/detailsPage/UPDATE_INTERROGATION_ERROR',
  UPDATE_INTERROGATION_SUCCESS:
    'processes/customInterrogations/detailsPage/UPDATE_INTERROGATION_SUCCESS',
  DELETE_INTERROGATION_ERROR:
    'processes/customInterrogations/detailsPage/DELETE_INTERROGATION_ERROR',
  DELETE_INTERROGATION_REQUEST:
    'processes/customInterrogations/detailsPage/DELETE_INTERROGATION_REQUEST',
  DELETE_INTERROGATION_SUCCESS:
    'processes/customInterrogations/detailsPage/DELETE_INTERROGATION_SUCCESS',
  OPEN_INPUTS_EDITOR:
    'processes/customInterrogations/detailsPage/OPEN_INPUTS_EDITOR',
  CLOSE_INPUTS_EDITOR:
    'processes/customInterrogations/detailsPage/CLOSE_INPUTS_EDITOR',
  OPEN_SELECTOR_MODAL:
    'processes/customInterrogations/detailsPage/OPEN_SELECTOR_MODAL',
  CLOSE_SELECTOR_MODAL:
    'processes/customInterrogations/detailsPage/CLOSE_SELECTOR_MODAL',
};

export const receiveCustomInterrogation = ({ customInterrogation }) => ({
  type: types.RECEIVE_CUSTOM_INTERROGATION,
  payload: normalize(customInterrogation, customInterrogationSchema),
});

export const update = {
  request: ({ id, data }) => ({
    type: types.UPDATE_INTERROGATION_REQUEST,
    payload: { id, data },
  }),
  success: ({ customInterrogation }) => ({
    type: types.UPDATE_INTERROGATION_SUCCESS,
    payload: normalize(customInterrogation, customInterrogationSchema),
  }),
  error: notify(
    (error) => ({
      type: types.UPDATE_INTERROGATION_ERROR,
      payload: error,
    }),
    'Failed to update Custom Interrogation',
  ),
};

export const inputsEditor = {
  open: () => ({
    type: types.OPEN_INPUTS_EDITOR,
  }),
  close: () => ({
    type: types.CLOSE_INPUTS_EDITOR,
  }),
};

export const selectorModal = {
  open: ({ selectorType }) => ({
    type: types.OPEN_SELECTOR_MODAL,
    payload: { selectorType },
  }),
  close: ({ selectorType }) => ({
    type: types.CLOSE_SELECTOR_MODAL,
    payload: { selectorType },
  }),
};

export const deleteInterrogation = {
  error: notify(
    (error) => ({
      type: types.DELETE_INTERROGATION_ERROR,
      payload: error,
    }),
    'Failed to delete custom interrogation',
  ),
  request: () => ({
    type: types.DELETE_INTERROGATION_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_INTERROGATION_SUCCESS,
    }),
    'Successfully deleted custom interrogation',
  ),
};
